import React from "react";
import { FieldProps } from "react-jsonschema-form";
import FileUploader, { FileUploaderProps } from "../../../components/file-uploader/file-uploader";
import { convertFilesToBase64 } from "../../../helpers/file.util";

interface FileInputDragAndDropProps extends FieldProps {
    options: FileUploaderProps;
}

// Must be in sync with backend upload
export const fileWhitelist = [
    'image/*', 
    'application/msword',
    'application/pdf',  
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', 
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv',
];

const FileInputDragAndDrop: React.FC<FileInputDragAndDropProps> = (props) => {
    const change = async (files: File[]) => {
        const filesToBase64 = await convertFilesToBase64(files);
        props.onChange(filesToBase64);
    };

    return (
        <FileUploader
            {...props.options}
            canDeleteFile={true}
            allowedExtensions={fileWhitelist}
            onChange={change}
            className="p-5"
        />
    );
};

export default FileInputDragAndDrop;
